import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UseGeneral from "../../hooks/useGeneral";
import { FaArrowLeft, FaArrowRight, FaEye, FaEyeSlash } from "react-icons/fa";
import "../Login/login.css";
import "./sign.css";
import { Axios } from "../../Axios";
import { BASE_URL } from "../../Axios/base_url";
import { ThreeDots } from "react-loader-spinner";
import toast from "react-hot-toast";
import { RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { auth } from "../../firebase";

const Sign = () => {
  const { language } = UseGeneral();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    password: "",
    phone: "",
  });
  const countries = [
    { code: "AE", name: "United Arab Emirates", name_ar: "الإمارات", dialCode: "+971" },
    { code: "OM", name: "Oman", name_ar: "عمان", dialCode: "+968" },
  ];

  const handleCountryChange = (e) => {
    const selectedCountry = countries.find(
      (country) => country.code === e.target.value
    );
    setUserData({
      ...userData,
      country: selectedCountry.code,
      countryCode: selectedCountry.dialCode,
    });
  };
  const handlePhoneChange = (e) => {
    console.log(e)
    if (userData?.phone?.toString()?.length <= 9)
      setUserData({ ...userData, phone: (e.target.value) });
  };
  useEffect(() => {
    if (localStorage?.getItem("GreenTreesToken")) {
      window.location.href = "/profile";
    }
    // generateRecaptcha();
  }, []);
  const [writeConfirmCode, setWriteConfirmCode] = useState(false);
  const [code, setcode] = useState(null);
  const [writedCode, setWritedCode] = useState(null);

  const generateRecaptcha = () => {
    try {
      window.recaptchaVerifier = new RecaptchaVerifier(
        "recaptcha",
        {
          size: "invisible",
          callback: (response) => {
            // reCAPTCHA solved, allow signInWithPhoneNumber.
          },
        },
        auth
      );
      window.recaptchaVerifier.render();
    } catch (err) {
      console.log(err);
    }
  };

  const signUps = (e) => {
    e.preventDefault();

    if (!userData.email) {
      toast.error(
        language === "ar" ? "قم بإدخال البريد الإلكترونى أولا" : "Enter Email"
      );
      return;
    }
    if (!userData.password) {
      toast.error(
        language === "ar" ? "قم بإدخال كلمة سر أولا" : "Enter Password"
      );
      return;
    }
    if (!userData.phone) {
      toast.error(
        language === "ar" ? "قم بإدخال رقم الهاتف أولا" : "Enter Phone"
      );
      return;
    }
    setWriteConfirmCode(true);

    generateRecaptcha();
    const appVerifier = window.recaptchaVerifier;
    const phoneNumber = userData.phone;

    signInWithPhoneNumber(auth, phoneNumber, appVerifier)
      .then((confirmationResult) => {
        console.log(confirmationResult);
        window.confirmationResult = confirmationResult;
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to send verification code. Please try again.");
      });
  };

  const signUp = (e) => {
    e.preventDefault();

    if (userData.email == "") {
      toast.error(
        language == "ar" ? "قم بإدخال البريد الإلكترونى أولا" : "Enter Email"
      );
      return;
    }
    if (userData.password == "") {
      toast.error(
        language == "ar" ? "قم بإدخال كلمة سر أولا" : "Enter Password"
      );
      return;
    }
    if (userData.phone == "") {
      toast.error(
        language == "ar" ? "قم بإدخال رقم الهاتف أولا" : "Enter Phone"
      );
      return;
    }
    setLoading(true);
    Axios({
      url: BASE_URL + "user/sign_up",
      method: "POST",
      data: userData,
      language: language,
    })
      .then((res) => {
        if (res?.status == "success") {
          toast.success(res?.message);
          window.location.href = "/login";
        } else toast.error(res.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  return (
    <div className="login_page sign_page">
      {!writeConfirmCode ? (
        <div className="login_content">
          <div className="right">
            <img src={require("../../assets/images/pana.png")} alt="" />
          </div>
          <div className="left">
            <h5>{language == "ar" ? "مرحبا" : "Welcome"}</h5>
            <h4>{language == "ar" ? "عميل جديد" : "New Client"}</h4>
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                if (!confirmed) {
                  toast.error(
                    language == "ar"
                      ? "قم بالموافقه على الشروط أولا"
                      : "Confirm To Condition"
                  );
                  return;
                }
                !loading ? signUps(e) : e.preventDefault();
              }}
            >
              <div>
                <label htmlFor="phone my-2">
                  {language == "ar" ? "الإسم" : "Name"}
                </label>
                <input
                  placeholder={
                    language == "ar" ? "أدخل إسمك الثلاثى" : "Enter Your Name"
                  }
                  type="text"
                  maxLength={255}
                  max={255}
                  className="form-control"
                  name="name"
                  required
                  id="name"
                  onChange={(e) =>
                    setUserData({ ...userData, name: e.target.value })
                  }
                />
              </div>
              <div>
                <label htmlFor="phone my-2">
                  {language == "ar" ? "البريد الإلكترونى" : "Email"}
                  <span className="star">*</span>
                </label>
                <input
                  placeholder={
                    language == "ar"
                      ? "أدخل البريد الإلكترونى"
                      : "Enter Your Email"
                  }
                  type="email"
                  className="form-control"
                  name="email"
                  id="email"
                  maxLength={50}
                  required
                  onChange={(e) =>
                    setUserData({ ...userData, email: e.target.value })
                  }
                />
              </div>
              <div className="phone-input-component">
                <div className="form-group">
                  <label
                    htmlFor="phone"
                    className="my-2"
                    style={{ width: "300px" }}
                  >
                    {language === "ar" ? "رقم الهاتف" : "Phone Number"}
                    <span className="star">*</span>
                  </label>
                  <div className="d-flex">
                    <select
                      name="country"
                      id="country"
                      className="form-control country-select"
                      value={userData.country}
                      onChange={handleCountryChange}
                    >
                      {countries.map((country) => (
                        <option key={country.dialCode} value={country.code}>
                          {language === "ar" ? country.name_ar : country.name}{" "}
                          {"  "} ({country.dialCode})
                        </option>
                      ))}
                    </select>
                    <input
                      placeholder={
                        language === "ar"
                          ? "أدخل رقم الهاتف"
                          : "Enter Your Phone"
                      }
                      type="text"
                      className="form-control"
                      name="phone"
                      required
                      maxLength={9}
                      onWheel={(e) => e.target.blur()}
                      // max={9}
                      id="phone"
                      value={userData.phone}
                      onChange={handlePhoneChange}
                    />
                  </div>
                  {language === "ar" ? (
                    <span>يستخدم هذا الرقم لتسجيل الدخول لحسابك</span>
                  ) : (
                    <span>This Number is Used to Sign In to Your Account</span>
                  )}
                </div>
              </div>
              <div>
                <label htmlFor="phone my-2">
                  {language == "ar" ? "كلمة المرور" : "Password"}
                  <span className="star">*</span>
                </label>
                <div className="div_pass_input">
                  <input
                    placeholder={
                      language == "ar" ? "أدخل كلمة المرور" : "Enter Password"
                    }
                    type={showPass ? "text" : "password"}
                    className="form-control"
                    name="password"
                    required
                    id="password"
                    
                    onChange={(e) =>
                      setUserData({ ...userData, password: e.target.value })
                    }
                  />
                  {showPass ? (
                    <FaEye
                      onClick={() => {
                        setShowPass(!showPass);
                      }}
                    />
                  ) : (
                    <FaEyeSlash
                      onClick={() => {
                        setShowPass(!showPass);
                      }}
                    />
                  )}
                </div>
                {language == "ar" ? (
                  <span>يجب أن تكون مكونه من 8 أجزاء</span>
                ) : (
                  <span>Must Consist Of 8 Parts</span>
                )}
              </div>
              <div id="recaptcha"></div>
              <div className="conf_parent">
                <input
                  checked={confirmed}
                  onClick={() => {
                    setConfirmed(!confirmed);
                  }}
                  style={{ borderRadius: "50%" }}
                  type="checkbox"
                />
                {language == "ar" ? (
                  <div className="conf_txt">
                    <p>أوافق على</p>
                    <p>الشروط والاحكام</p>
                  </div>
                ) : (
                  <div className="conf_txt">
                    <p>I agree</p>
                    <p>Terms and Conditions</p>
                  </div>
                )}
              </div>
              {loading ? (
                <ThreeDots
                  visible={true}
                  height="80"
                  width="80"
                  color="#4fa94d"
                  radius="9"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              ) : (
                <button
                // style={{
                //   cursor:!confirmed?'no-drop':'pointer',
                // }}
                // disabled={!confirmed}
                >
                  {language == "ar" ? "إنشاء حساب" : "Create Account"}
                </button>
              )}
              {language == "ar" ? (
                <div
                  onClick={() => {
                    navigate("/login");
                  }}
                  className="create_new_text"
                >
                  <p>لديك حساب ؟</p>
                  <p>تسجيل الدخول</p>
                </div>
              ) : (
                <div
                  onClick={() => {
                    navigate("/login");
                  }}
                  className="create_new_text"
                >
                  <p>Do You Have An Account ?</p>
                  <p>Create An Account</p>
                </div>
              )}
            </form>
          </div>
        </div>
      ) : (
        <div className="login_content">
          <div className="right">
            <img src={require("../../assets/images/pana.png")} alt="" />
          </div>
          <div className="left">
            <h5>{language == "ar" ? "مرحبا" : "Welcome"}</h5>
            <h4>{language == "ar" ? "عميل جديد" : "New Client"}</h4>
            <span
              onClick={() => setWriteConfirmCode(null)}
              style={{ cursor: "pointer" }}
            >
              {language == "ar" ? <FaArrowRight /> : <FaArrowLeft />}
            </span>
            <form
              action=""
              onSubmit={(e) => {
                e.preventDefault();
                if (!confirmed) {
                  toast.error(
                    language == "ar"
                      ? "قم بالموافقه على الشروط أولا"
                      : "Confirm To Condition"
                  );
                  return;
                }
                !loading ? signUp(e) : e.preventDefault();
              }}
            >
              <div>
                <label htmlFor="code my-2">
                  {language == "ar" ? "الكود" : "Code"}
                </label>
                <input
                  placeholder={
                    language == "ar" ? "قم بإدخال الكود" : "Enter The Code"
                  }
                  type="text"
                  className="form-control"
                  name="code"
                  required
                  id="code"
                  onChange={(e) => setWriteConfirmCode(e.target.value)}
                />
              </div>

              {loading ? (
                <ThreeDots
                  visible={true}
                  height="80"
                  width="80"
                  color="#4fa94d"
                  radius="9"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              ) : (
                <button
                // style={{
                //   cursor:!confirmed?'no-drop':'pointer',
                // }}
                // disabled={!confirmed}
                >
                  {language == "ar" ? "تأكيد" : "Confirm"}
                </button>
              )}
              {language == "ar" ? (
                <div
                  onClick={() => {
                    navigate("/login");
                  }}
                  className="create_new_text"
                >
                  <p>لديك حساب ؟</p>
                  <p>تسجيل الدخول</p>
                </div>
              ) : (
                <div
                  onClick={() => {
                    navigate("/login");
                  }}
                  className="create_new_text"
                >
                  <p>Do You Have An Account ?</p>
                  <p>Create An Account</p>
                </div>
              )}
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sign;
